import PropTypes from 'prop-types';
import FormHelperText from '@material-ui/core/FormHelperText';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';

class FormInfo extends React.PureComponent {

    render() {

        const { classes } = this.props;

        return (
            <FormHelperText data-test="form-info" className={classes.infoHelp}>{this.props.children}</FormHelperText>
        );
    }
}

FormInfo.propTypes = {
    classes: PropTypes.object,
    children: PropTypes.any
};

export default withStyles(styles)(FormInfo);